import { render } from "./TextPe.vue?vue&type=template&id=57c73116"
import script from "./TextPe.vue?vue&type=script&lang=js"
export * from "./TextPe.vue?vue&type=script&lang=js"

import "./TextPe.vue?vue&type=style&index=0&id=57c73116&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__